/* eslint-disable react-perf/jsx-no-new-function-as-prop */
import { Group, Modal, Text } from "@mantine/core";
import { CellContext, ColumnDef, createColumnHelper } from "@tanstack/react-table";
import { useState } from "react";
import { textMapIdeias } from "@/src/routes/gestao-inovacao-page/ExportIdeias";
import { TIdeiaProcessada } from "../hooks/useIdeiasRelatorio";

const columnHelper = createColumnHelper<TIdeiaProcessada>();

/**
 * Component to display text with modal for long content
 * @param properties - Cell context properties containing the text value
 * @param titulo - Title to display in the modal header
 * @returns JSX element with truncated text and modal for full content
 */
function GetTexto(properties: CellContext<TIdeiaProcessada, string | null | undefined>, titulo: string) {
  const maxTexto = 150;
  const [opened, setOpened] = useState(false);
  const originalText = properties.getValue();
  if (!originalText) return null;

  const isTooLong = originalText.length > maxTexto;
  const truncatedText = isTooLong ? `${originalText.slice(0, maxTexto)} ...` : originalText;
  const handleOpen = () => {
    if (isTooLong) {
      setOpened(true);
    }
  };
  const handleClose = () => setOpened(false);
  return (
    <>
      <Group gap="xs" wrap="nowrap">
        <Text fz="sm" style={{ cursor: isTooLong ? "pointer" : "default" }} onClick={handleOpen}>
          {truncatedText}
        </Text>
      </Group>
      <Modal opened={opened} onClose={handleClose} title={titulo}>
        <Text>{originalText}</Text>
      </Modal>
    </>
  );
}

const columns: ColumnDef<TIdeiaProcessada>[] = [
  columnHelper.accessor("regulamentoNome", {
    header: "Regulamento",
    cell: (properties) => <Text fz="sm">{properties.getValue()}</Text>
  }),
  columnHelper.accessor("autorNome", {
    header: "Autor(es)",
    cell: (properties) => <Text fz="sm">{properties.getValue()}</Text>
  }),
  columnHelper.accessor("titulo", {
    header: "Título",
    cell: (properties) => <Text fz="sm">{properties.getValue()}</Text>
  }),
  columnHelper.accessor("descricao", {
    header: "Descrição",
    cell: (properties) => GetTexto(properties, "Descrição")
  }),
  columnHelper.accessor("descricaoProblema", {
    header: "Descrição do Problema",
    cell: (properties) => GetTexto(properties, "Descrição do Problema")
  }),
  columnHelper.accessor("diferenciais", {
    header: "Diferenciais",
    cell: (properties) => GetTexto(properties, "Diferenciais")
  }),
  columnHelper.accessor("feedback", {
    header: "Feedback",
    cell: (properties) => GetTexto(properties, "Feedback")
  }),
  columnHelper.accessor("autorEmail", {
    header: "Email Autor(es)",
    cell: (properties) => <Text fz="sm">{properties.getValue()}</Text>
  }),
  columnHelper.accessor("createdAt", {
    header: "Data Criação",
    cell: (properties) => <Text fz="sm">{properties.getValue()?.toLocaleDateString()}</Text>
  }),
  columnHelper.accessor("curtidas", {
    header: "Curtidas",
    cell: (properties) => <Text fz="sm">{properties.getValue()}</Text>
  }),
  columnHelper.accessor("comentarios", {
    header: "Comentários",
    cell: (properties) => <Text fz="sm">{properties.getValue()}</Text>
  }),
  columnHelper.accessor("moedas", {
    header: "Patrocínios",
    cell: (properties) => <Text fz="sm">{properties.getValue()}</Text>
  }),
  columnHelper.accessor("status", {
    header: "Status",
    cell: (properties) => <Text fz="sm">{textMapIdeias[properties.getValue()]}</Text>
  })
];

export default columns;
